import { useEffect, useState } from "react";
import { useTranslation } from "@/contexts/TranslationContext";

interface TranslatedTextProps {
  text: string;
  className?: string;
}

export function TranslatedText({ text, className }: TranslatedTextProps) {
  const { translate, currentLanguage } = useTranslation();
  const [translatedText, setTranslatedText] = useState(text);

  useEffect(() => {
    if (currentLanguage === "nl") {
      setTranslatedText(text);
      return;
    }

    let isMounted = true;
    
    translate(text).then(result => {
      if (isMounted) {
        setTranslatedText(result);
      }
    });

    return () => {
      isMounted = false;
    };
  }, [text, currentLanguage, translate]);

  return <span className={className}>{translatedText}</span>;
}
